import React from 'react'

export default function BasicHotspot() {
  return <div style={{ backgroundColor: 'red', height: 30, width: 30 }} />
}
